jQuery(document).ready(function($) {
	postsAjax($);
});

function postsAjax($) {

    const $postsAjax = $('.js-posts-ajax');
    if (!$postsAjax.length)
        return;
    const $body = $('body');
    const $postsFilter = $postsAjax.find('.js-posts-filter');
    const $selects = $postsFilter.find('select');
    const $postsContainer = $postsAjax.find('.js-posts');
    const $clearBtn = $postsAjax.find('.js-clear');
    let query = {
        'taxSkills' : null,
        'taxSectors' : null,
    };

    $clearBtn.on('click', function(e) {

        e.preventDefault();

        query = {
            'taxSkills' : null,
            'taxSectors' : null,
        };

        updatePosts();

        $clearBtn.addClass('hidden');

    });

    $selects.on('change', function() {

        const $select = $(this);
        updatePosts($select);

    });

    function updatePosts( $select = null) {

        $postsAjax.addClass('loading');
        $clearBtn.removeClass('hidden');

        if ( $select ) {
            switch ( $select.data('type') ) {
                case 'skills':
                    query.taxSkills = $select.val();
                    break;
                case 'sectors':
                    query.taxSectors = $select.val();
                    break;
            }
        }

        getPostsAjax( function(res) {
            if ( res.success == true )  {

                $postsContainer.html(res.data.html);
                const taxArr = res.data.filterContent.taxonomies;

                $.each(taxArr, function(taxonomy, terms) {

                    if ( $select.data('type') === taxonomy ) return;

                    const $options = $selects.filter('#'+taxonomy).find('.js-param');
                    
                    $.each($options, function(key, option) {

                        const $option = $(option);

                        if ( parseInt(taxArr[taxonomy].indexOf(parseInt($option.val()))) === -1 ) {
                            $option.addClass('hidden');
                        }
                        else {
                            $option.removeClass('hidden');
                        }

                    });
                });
                $postsAjax.removeClass('loading');
            }
            else {
                console.log(res) ;
            }
        });

    }


    function getPostsAjax( callback ) {
        $.ajax({
            url: localizedData.adminAjaxUrl,
            type: "POST",
            cache: false,
            data: {
                action: 'get_posts_ajax',
                taxSkills : query.taxSkills,
                taxSectors : query.taxSectors,
            },
            success: function(res) {
                callback(res);
            }
        });
    }

}